import NextHead from 'next/head'

interface MetaCanonicalProps {
  url: string
}

export function MetaCanonical({ url }: MetaCanonicalProps) {
  return (
    <NextHead>
      <link rel="canonical" href={url} key="canonical" />
    </NextHead>
  )
}
